import { buildAppTakeoverConfig } from '../../build-app-takeover-config';
import type { TakeoverRuntimeBindings } from '../../build-app-takeover-config';

import { manifest } from './manifest';

const assets: TakeoverRuntimeBindings<typeof manifest>['assets'] = {
  splash: require('./assets/splash.mp4'),
  sectionHeader: require('./assets/section-header.webp'),
  primarySectionBackground: require('./assets/primary-section-bg.webp'),
  whopperTopper: require('./assets/whopper-topper.webp'),
  whopperSectionBackground: require('./assets/whopper-section-bg.webp'),
  friesTopper: require('./assets/fries-topper.webp'),
  friesSectionBackground: require('./assets/fries-section-bg.webp'),
  onionRingsTopper: require('./assets/onion-rings-topper.webp'),
  onionRingsSectionBackground: require('./assets/onion-rings-section-bg.webp'),
  nuggetsTopper: require('./assets/nuggets-topper.webp'),
  nuggetsSectionBackground: require('./assets/nuggets-section-bg.webp'),
  productShotBackground: require('./assets/product-shot-bg.webp'),
  checkout: require('./assets/checkout.mp4'),
};

const components: TakeoverRuntimeBindings<typeof manifest>['components'] = {};

export const elevation = buildAppTakeoverConfig(manifest, { assets, components });
